import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { getLang } from '@gif/shared-global';

import { App } from './components';

// release not finding affected apps... so I'm going to add a comment here to see if it triggers a release
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const lang = getLang();
root.render(
  <StrictMode>
    <BrowserRouter
      future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
      basename={`${lang === 'es' ? `/${lang}` : ''}/play`}
    >
      <App />
    </BrowserRouter>
  </StrictMode>
);
